import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination, notification, Space } from 'antd';
import { PageTitle } from '../../../../../_template/layout/core/PageData';
import './Widget.css';
import AddChatWidgetForm from './component/AddChatWidgetForm';
import WidgetList from './component/WidgetList';
import SearchForm from './component/SearchForm';

const TruChatWidget = () => {
    const loginUserType = localStorage.getItem('type');

    let pageTitle
    if(loginUserType === 'A'){
        pageTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
            {
                title: 'Guide',
                path: '/guide/overview',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
    else if(loginUserType === 'D'){
        pageTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
   
    const api_base_url = process.env.REACT_APP_API_URL;
    const [allWidgetData, setAllWidgetData] = useState([]);
    const [widgetId, setWidgetId] = useState(null);
    const [loaderStatus, setLoaderStatus] = useState(false);

    const [totalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const dataLimit = 20;
    
    useEffect(()=>{
        getAllWidget();
    },[])

    const getAllWidget = async(event, page_no) => {
        try {
            setLoaderStatus(true);
            const api_params = {};

            let apiToken = '';
            if(loginUserType === 'A'){
                apiToken = localStorage.getItem('token')
            }
            else if(loginUserType === 'D'){
                apiToken = localStorage.getItem('developertoken')
            }
            else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }


            const api_headers = {
                headers: { 
                   "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            if(event) {
                api_params.widget_name = event.widget_name
            }
            api_params.page = page_no ? page_no : page;;
            api_params.limit = dataLimit;
            api_params.sass_id = localStorage.getItem('sass_id');

            await axios.post(`${api_base_url}admin/get-all-widget`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        setLoaderStatus(false);
                        setAllWidgetData(res.data.data.allWidgetData);
                        setTotalRecord(res.data.data.paginationData.total_count);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setLoaderStatus(false);
                }) 
        } catch (error) {
            console.error("Error submitting form:", error);
            setLoaderStatus(false);
        } finally {
            setLoaderStatus(false);
        }
    }

    const handelRecordInserted = (event) => {
        setAllWidgetData(prevState => ([event, ...prevState]));
    }

    const handelRecordDeleted = (event) => {
        setAllWidgetData((prevState) => prevState.filter((item) => item.widget_id !== event.widget_id));
    };

    const handelEditWidget = (event) => {
        setWidgetId(event.widget_id);
    }

    const handelRecordUpdated = (widget_id, newData) => {
        const updatedData = allWidgetData.map(widget =>
            widget.widget_id === widget_id
                ? { ...widget, ...newData }
                : widget
        );
        setAllWidgetData(updatedData);
        setWidgetId('');
    }

    const onChange = (page) => {
        setPage(page);
        getAllWidget(null, page);
    };

    return (
        <>
            <PageTitle breadcrumbs={pageTitle}>
                Truchat Widget
            </PageTitle>

            <AddChatWidgetForm recordInserted={handelRecordInserted} widgetId={widgetId} recordUpdated={handelRecordUpdated} totalRecords={totalRecord} searchWidget={getAllWidget} loader_status={loaderStatus} />
            <WidgetList allWidgets={allWidgetData} widgetDeleted={handelRecordDeleted} widgetEditId={handelEditWidget} />

            <div className="row mt-5">
                <Pagination 
                    align="end" 
                    defaultPageSize={20}
                    defaultCurrent={1} 
                    current={page} 
                    onChange={onChange}
                    total={totalRecord}  
                    hideOnSinglePage={false}
                />
            </div>
        </>
        
    )
}

export default TruChatWidget;